/*@ngInject*/
const UIPhoneNumberFormatterDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm, $attrs, ngModelController) {

        function runFormat() {
            let viewValue, viewValueNoDash;
            if (ngModelController.$viewValue.toString().length === 10) {
                viewValueNoDash = _.replace(ngModelController.$viewValue.toString(), '-', '');
                viewValue = viewValueNoDash.toString().slice(0, 3) + '-' + viewValueNoDash.toString().slice(3, 6) + '-' + viewValueNoDash.toString().slice(6);
                ngModelController.$setViewValue(viewValue);
                ngModelController.$render();
            }
        }

        function handleBlur() {
            runFormat();
        }

        $($elm).on('blur', handleBlur);

        $scope.$on('$destroy', function () {
            $($elm).off('blur', handleBlur);
        });

        $timeout(function () {
            if (ngModelController.$viewValue) {
                runFormat();
            }
        }, 300);
    };

    return {
        restrict: 'A',
        link: linkFunction,
        require: 'ngModel'
    };
};

angular.module('umCore')
    .directive('uiPhoneNumberFormatter', UIPhoneNumberFormatterDirective);
